/**
 * 应用全局配置文件
 */

// API 主机地址 - 使用相对路径，自动适配当前域名
export const apiHostname = '';

// 其他全局配置
export const appConfig = {
  defaultPageSize: 10,
  dateFormat: 'YYYY-MM-DD',
  appName: '铖序员'
}; 